<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'KalkulatorKontribusi',

    metaInfo: { title: 'Kalkulator Kontribusi' },

    extends: View,

    mixins: [
      LoadSections([
        'calculator',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'calculator',
      },
    },
  }
</script>
